export class EmailCode{
    email!:string;
    clientNumber!:number;
    code!:string;
}

export class CodeResponse{
    isSuccess!:boolean;
    message!:string;
    otp!:string;
}